import * as Types from '../../gql.generated';

import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';
export type ProvingIdsQueryVariables = {};


export type ProvingIdsQuery = (
  { __typename?: 'Query' }
  & { provings: Array<(
    { __typename?: 'Proving' }
    & Pick<Types.Proving, 'id'>
  )> }
);

export const ProvingIdsDocument = gql`
    query ProvingIds {
  provings {
    id
  }
}
    `;

    export function useProvingIdsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ProvingIdsQuery, ProvingIdsQueryVariables>) {
      return ApolloReactHooks.useQuery<ProvingIdsQuery, ProvingIdsQueryVariables>(ProvingIdsDocument, baseOptions);
    };
      export function useProvingIdsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProvingIdsQuery, ProvingIdsQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<ProvingIdsQuery, ProvingIdsQueryVariables>(ProvingIdsDocument, baseOptions);
      };
      
export type ProvingIdsQueryHookResult = ReturnType<typeof useProvingIdsQuery>;
export type ProvingIdsQueryResult = ApolloReactCommon.QueryResult<ProvingIdsQuery, ProvingIdsQueryVariables>;